module.exports = __webpack_public_path__ + "405cfe28243a7ee1e778b3f6aadad6e4.png";